<template>
  <div id="contenedor-main-contrato-frentes">
    <v-card
    flat>
    <v-card-text>
      <!-- ToolBar -->
      <tool-bar
        v-if="!$apollo.queries.contratoFrentes.loading"
        class="my-3"
        v-on:nuevoFrente="registrarNuevoFrente">
      </tool-bar>
      <!-- Loader -->
      <v-skeleton-loader
        v-if="$apollo.queries.contratoFrentes.loading"
        type="table-heading, table-thead, table-tbody"
      >
      </v-skeleton-loader>
      <listado
          v-if="!$apollo.queries.contratoFrentes.loading && contratoFrentes.length > 0"
          :listado="getListadoFrentes">
        </listado>
        <!-- Mensaje de alertar de que no existe frentes registrados -->
        <v-alert
          v-else
          type="info">
          No se encontraron registros.
        </v-alert>
      </v-card-text>
    </v-card>
    <!-- Agregar contrato frente -->
    <v-dialog
      v-model="mostrarRegistrarFrente"
      width="450">
      <agregar-frente
        :id-contrato="$route.params.idContrato"
        v-on:cerrar="cerrarVentana">
      </agregar-frente>
    </v-dialog>
    <!-- Editar contrato frente -->
    <v-dialog
      v-model="mostrarEditarFrente"
      width="450">
      <editar-frente
        v-if="esteFrente"
        :frente-editar="esteFrente"
        v-on:cerrar="cerrarVentana">
      </editar-frente>
    </v-dialog>
    <!-- Borrar contrato frente -->
    <v-dialog
      v-model="mostrarEliminarFrente"
      width="450">
      <eliminar-frente
      v-if="esteFrente"
        :contrato-frente="esteFrente"
        v-on:cerrar="cerrarVentana">
      </eliminar-frente>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO_FRENTES from '@/graphql/querys/administracion/contratos/contrato/frentes/contratoFrentes.gql';
import eventBus from '@/helpers/eventBus';
import agregarFrente from '@/components/administracion/contratos/contrato/frentes/Nuevo.vue';
import editarFrente from '@/components/administracion/contratos/contrato/frentes/Editar.vue';
import eliminarFrente from '@/components/administracion/contratos/contrato/frentes/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import listado from './listado/Main.vue';

export default {
  name: 'MainContratoFrentes',
  components: {
    ToolBar,
    agregarFrente,
    editarFrente,
    eliminarFrente,
    listado,
  },
  data() {
    return {
      mostrarRegistrarFrente: false,
      mostrarEditarFrente: false,
      mostrarEliminarFrente: false,
      esteFrente: null,
    };
  },
  mounted() {
    eventBus.$on('editar-frente-contrato', (frente) => {
      this.esteFrente = frente;
      this.mostrarEditarFrente = true;
    });
    eventBus.$on('eliminar-frente-contrato', (frente) => {
      this.esteFrente = frente;
      this.mostrarEliminarFrente = true;
    });
  },
  apollo: {
    contratoFrentes: {
      query: CONTRATO_FRENTES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    registrarNuevoFrente() {
      this.mostrarRegistrarFrente = true;
    },
    cerrarVentana() {
      this.mostrarRegistrarFrente = false;
      this.mostrarEditarFrente = false;
      this.mostrarEliminarFrente = false;
      this.esteFrente = null;
    },
  },
  computed: {
    getListadoFrentes() {
      return this.contratoFrentes.slice().sort((a, b) => a.orden - b.orden);
    },
  },
};
</script>

<style lang="scss">

</style>
